// extracted by mini-css-extract-plugin
export default {"loginSignupHeader":"login_loginSignupHeader__6bQyv","loginForm":"login_loginForm__8pLv9","field":"login_field__q1hrv"};